export default "__VITE_ASSET__BZYPbNMO__"